import Trainer from "./Trainer";
export default Trainer;
